import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import InvoiceCard from "../../components/InvoiceCard";
import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { INVOICE_FOR_DOC_COLUMNS } from "../../columns/columns";
import AlertDialog from "../../components/AlertDialog";
import ColouredChip from "../../components/ColouredChip";
import Empty from "../../components/error/Empty";
import BasicEditableTable from "../../components/table/BasicEditableTable";
import { editableTableDefaultColumn } from "../../components/table/cell/EditableCell";
import { getUser } from "../../services/authService";
import {
  getInvoiceFile,
  getPOAccountInvoice,
  getSupplierInvoiceDetails,
  informCargoDelayMail,
  informCargoReadyMail,
  insertSupplierInvoiceDoc,
  sendInvoiceCreatedEmail,
  updateCargoDelayedDate,
  updateCargoReadyDate,
} from "../../services/dataService";
import { today } from "../../manager/dateManager";
import { ReactComponent as AmmountError } from "../../assets/svg/amountError.svg";
import {
  ImpexAdmin,
  ImpexFinance,
  ImpexOperations,
} from "../../global-const/permissionName";
import { useNavigate } from "react-router-dom";
//import { validatepartnumber } from "../../services/dataService";

const largeInvoiceView = [ImpexAdmin, ImpexFinance, ImpexOperations];

function InvoiceDetails() {
  const { POID } = useParams();
  const [queryParams] = useSearchParams();
  const invoiceNum = queryParams.get("inv");
  const user = getUser();
  const isImpexOfficeUser = largeInvoiceView.includes(user.userDetails.role);
  const [originalInvoiceData, setOriginalInvoiceData] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);
  const [activeDoc, setActiveDOC] = useState("");
  const [invoiceAmtBySystem, setInvoiceAmtBySystem] = useState(0);
  const [invoiceDoc, setInvoiceDoc] = useState("");
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState(null);
  const [invoiceFilename, setInvoiceFilename] = useState(null);
  const [newInvoiceData, setNewInvoiceData] = useState({
    invoiceAmtByUser: 0,
    invoiceNumber: "",
  });
  const [invoicePartDetails, setInvoicePartDetails] = useState([]);
  /* const [validatepop, setvalidatepop] = useState(false);
  const [validateponumber, setvalidateponumber] = useState(""); */
  const navigate = useNavigate();
  const redirect = (e) => {
    navigate("/impex/invoices");
  }
  
  
  async function getPOAccountInvoiceDetails() {
    try {
      setLoading(true);
      const response = await getPOAccountInvoice(POID);
      const { Invoicedetail } = response.data;
      setInvoiceData(Invoicedetail);
      setOriginalInvoiceData(Invoicedetail);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function getInvoicePartDetails() {
    try {
      const response = await getSupplierInvoiceDetails(POID);
      let partsData = {};
      for (const item of response.data) {
        if (partsData.hasOwnProperty(item.InvoiceNo)) {
          partsData[item.InvoiceNo].AllParts.push({
            PartNo: item.PartNo,
            InvoiceQty: item.ReceivedQty,
            PartPrice: item.RatePerUnit,
          });
        } else {
          partsData[item.InvoiceNo] = {
            SupplierInvoiceDocumentsID: item.SupplierInvoiceDocumentsID,
            POID: item.POID,
            PONumber: item.PONumber,
            InvoiceNo: item.InvoiceNo,
            InvoiceAmount: item.InvoiceAmount,
            InvoiceDocLink: item.InvoiceDocLink,
            AllParts: [
              {
                PartNo: item.PartNo,
                InvoiceQty: item.ReceivedQty,
                PartPrice: item.RatePerUnit,
              },
            ],
            CargoReadyDate: item.CargoReadyDate,
            CargoDelayedDate: item.CargoDelayedDate,
          };
        }
      }
      setInvoicePartDetails(Object.values(partsData));
      if (!invoiceNum) {
        setActiveDOC(response.data[response.data.length - 1]["InvoiceDocLink"]);
      } else {
        setActiveDOC(
          Object.values(partsData).filter(
            (invo) => invo.InvoiceNo === invoiceNum
          )[0]["InvoiceDocLink"]
        );
      }
      const fileResponse = await getInvoiceFile(
        response.data[response.data.length - 1]["InvoiceDocLink"]
      );
      setInvoiceFilename(fileResponse.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getPOAccountInvoiceDetails();
    getInvoicePartDetails();
    /* handleInvoiceOpen(activeDoc); */
    // eslint-disable-next-line
  }, [POID]);

  const updateInvoiceData = (rowIndex, columnId, value) => {
    setInvoiceData((old) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          };
        }
        return row;
      })
    );
  };

  const setInvoiceByUser = (invAmount) => {
    setNewInvoiceData({
      ...newInvoiceData,
      invoiceAmtByUser: invAmount,
    });
  };

  useEffect(() => {
   // handleInvoiceOpen(activeDoc);
    var invAmount = 0;
    invoiceData.forEach((row, index) => {
      if (row.invoiceQty) {
        invAmount += parseInt(row.invoiceQty) * row.RatePerUnit;
      }
    });
    const invoiceAMT = Math.round(invAmount * 100) / 100;
    setInvoiceAmtBySystem(invoiceAMT);
    setInvoiceByUser(invoiceAMT);

    // eslint-disable-next-line
  }, [invoiceData, originalInvoiceData]);

  const updateInvoiceDetails = async (e) => {
    //const validatepartarr = [];

    e.preventDefault();
    let isFalse = false;
    try {
     /*  var validatepartpayload = {
        POID: POID,
        PONumber: invoiceData[0]["PONumber"],
        _TVP_SupplierInvoiceslist: validatepartarr,
      }; */
      var payload = new FormData();
      payload.append("POID", POID);
      payload.append("PONumber", invoiceData[0]["PONumber"]);
      payload.append("InvoiceNo", newInvoiceData.invoiceNumber.trim());
      payload.append("InvoiceAmount", invoiceAmtBySystem);
      payload.append("File_InvoiceDocLink", invoiceDoc);
      payload.append("CreatedBy", user?.userDetails.UserId);

      for (const inv of invoiceData) {
        if (inv.invoiceQty && inv.invoiceQty > 0) {
          payload.append(
            "_SupplierInvoices",
            JSON.stringify({
              _SupplierInvoices: [
                {
                  POLineId: inv.POLineID,
                  PartNo: inv.PartNo,
                  Qty: inv.Qty,
                  RatePerUnit: inv.RatePerUnit,
                  PartRate: inv.RatePerUnit,
                  ReceivedQty: inv.invoiceQty,
                  BalancedQty: inv.InvoiceBalQty,
                },
              ],
            })
          );
        /*   validatepartarr.push({
            POLineId: inv.POLineID,
            PartNo: inv.PartNo,
            Qty: inv.Qty,
            RatePerUnit: inv.RatePerUnit,
            PartRate: inv.RatePerUnit,
            ReceivedQty: inv.invoiceQty,
            BalancedQty: inv.InvoiceBalQty,
          }); */
        }
      }
     /*  const validateresponse = await validatepartnumber(validatepartpayload);
      setvalidateponumber(validateresponse.data.PONumber);
      if (validateresponse.data.PONumber) {
        //toast.error(`This is not the correct PO as per FIFO basis, please fulfill/upload invoice against the PO No. ${value} first.`);
        setvalidatepop(true);
      } */

      if (
        invoiceDoc &&
        parseFloat(invoiceAmtBySystem) ===
          parseFloat(newInvoiceData.invoiceAmtByUser)
      ) {
        await insertSupplierInvoiceDoc(payload)
        getPOAccountInvoiceDetails();
        getInvoicePartDetails();
        toast.success("Details updated successfully");
        redirect();
      } else {
        setDialog(true);
        isFalse = true;
      }

      setNewInvoiceData({
        invoiceAmtByUser: 0,
        invoiceNumber: "",
      });
      e.target.reset();
      if (!isFalse) {
        await sendInvoiceCreatedEmail(POID, newInvoiceData.invoiceNumber);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.Message || error.response.data.message);
      }
    }
  };

  const isOrderCompleted = () => {
    var disable = 0;
    for (const inv of invoiceData) {
      if (inv.Qty === inv.ReceivedQty) {
        disable += 1;
      } else {
        disable -= 1;
      }
    }
    return invoiceData.length === disable;
  };

  const handleChange = (e) => {
    setNewInvoiceData({
      ...newInvoiceData,
      [e.target.name]: e.target.value,
    });
  };
  // const alertToImpex = async () => {
  //   const podate = moment(invoiceData && invoiceData[0]["PODate"]).format(
  //     "MMM YY"
  //   );
  //   try {
  //     const response = await getCCMailFromDB({
  //       params: { SendTo: "Impex" },
  //     });
  //     const toMails = response.data.TOMail;
  //     const ccMails = response.data.CCMail.split(",");
  //     const bccMails = response.data.BCCMail.split(",");
  //     await sendEmail({
  //       receiverAddress: toMails ? toMails : ccMails,
  //       cc: ccMails,
  //       bcc: bccMails,
  //       receiverName: "Impex Team",
  //       subject: `${user.userDetails.SupplierShortName}-${invoiceData[0]["PONumber"]}/${podate} - Supplier Invoice Warning for PO- ${invoiceData[0]["PONumber"]}`,
  //       HTML: wrongAmountAlert(
  //         invoiceData,
  //         newInvoiceData.invoiceAmtByUser,
  //         invoiceAmtBySystem
  //       ),
  //       attachments: [],
  //       templateId: "2",
  //       alertTime: today(true),
  //     });
  //     await addEmailLog({
  //       Mailto: toMails,
  //       MailCc: response.data.CCMail ? response.data.CCMail : "",
  //       MailSubject: `${user.userDetails.SupplierShortName}-${invoiceData[0]["PONumber"]}/${podate} - Supplier Invoice Warning for PO- ${invoiceData[0]["PONumber"]}`,
  //       FormName: "Wrong Invoice Alert",
  //       FunctionalityName: "Invoice details page",
  //       TriggerDatetime: today(true),
  //       UId: user.userDetails.UserId,
  //       HostName: "Test HostName",
  //       ProjectName: "ImpexPortal",
  //     });

  //     await sendWrongInvAmtNotification({
  //       POID: invoiceData[0]["POID"],
  //       CreatedBy: user.userDetails.UserId,
  //       InvoiceNo: newInvoiceData.invoiceNumber,
  //       CalculatedAmt: newInvoiceData.invoiceAmtByUser,
  //       InvoiceAmt: invoiceAmtBySystem,
  //     });
  //   } catch (error) {}
  // };

  const notifyCargoReady = async (id) => {
    try {
      const cargoPayload = new FormData();
      cargoPayload.append("SupplierInvoiceDocumentsID", id);
      cargoPayload.append("CargoReadyDate", today());
      await updateCargoReadyDate(cargoPayload);
      getInvoicePartDetails();
      toast.success("Impex has been informed that cargo is ready.");
      await informCargoReadyMail({
        SupplierInvoiceDocumentsID: id,
        POID: POID,
      });
    } catch (error) {
      toast.error("Unable to update Date");
    }
  };

  const notifyCargoDelay = async (id, date) => {
    try {
      const cargoDelayPayload = new FormData();
      cargoDelayPayload.append("SupplierInvoiceDocumentsID", id);
      cargoDelayPayload.append("CargoDelayedDate", today());
      await updateCargoDelayedDate(cargoDelayPayload);
      getInvoicePartDetails();
      toast.success("Impex has been informed that cargo is delay.");
      await informCargoDelayMail({
        SupplierInvoiceDocumentsID: id,
        POID: POID,
      });
    } catch (error) {
      toast.error("Unable to update Date");
    }
  };

  const handleAlertClose = () => {
    window.location.reload();
    setDialog(null);
  };

  const handleInvoiceOpen = async (invDoc) => {
    setActiveDOC(invDoc);
    try {
      const fileResponse = await getInvoiceFile(invDoc);
      setInvoiceFilename(fileResponse.data);
    } catch (error) {}
  };

  return (
    <>
   {/*    <AlertDialog
        open={validatepop}
        onConfirm={() => {
          setvalidatepop(false);
        }}
        onClose={() => {
          setvalidatepop(false);
          redirect();
        }}
        title={"Alert..!"}
        description={`This is not the correct PO as per FIFO basis, please fulfill/upload invoice against the PO No. ${validateponumber} first.`}
        isAlert={true}
      /> */}

      {dialog && (
        <AlertDialog
          open={dialog}
          svgFile={<AmmountError style={{ maxWidth: 250, width: "100%" }} />}
          onConfirm={handleAlertClose}
          title={"Amount Error"}
          description={
            "Invoice amount is not matching. Please contact Impex team"
          }
          isAlert={true}
          onClose={handleAlertClose}
          AmmountError={true}
        />
      )}
      {!loading && (
        <Grid container spacing={2}>
          <Grid
            item
            lg={isImpexOfficeUser ? 8 : 6}
            md={isImpexOfficeUser ? 8 : 6}
            xs={12}
            sx={{
              height: "80vh",
            }}
          >
            {invoiceFilename && (
              <iframe
                src={invoiceFilename}
                title="invoice"
                style={{
                  width: "100%",
                  minHeight: "86vh",
                  border: "none",
                  borderRadius: "3px",
                  align: "center",
                }}
                allowFullScreen
              />
            )}
            {!invoiceFilename && (
              <Empty
                title={"No invoices"}
                message={"No invoices has been prepared yet."}
              />
            )}
          </Grid>
          <Grid
            item
            lg={isImpexOfficeUser ? 4 : 6}
            md={isImpexOfficeUser ? 4 : 6}
            xs={12}
            sx={{}}
          >
            {!invoiceNum && (
              <Card
                sx={{
                  mb: 2,
                }}
              >
                <CardContent>
                  {invoiceData.length !== 0 && (
                    <>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography
                          component="h5"
                          marginBottom={2}
                          variant="h5"
                        >
                          {invoiceData[0]
                            ? `#${invoiceData[0]["PONumber"]}`
                            : ""}
                        </Typography>
                        {user?.isSupplierFinance && (
                          <Typography
                            component="h5"
                            variant="h6"
                            marginBottom={2}
                          >
                            INVOICE AMOUNT:-{" "}
                            <ColouredChip
                              label={invoiceAmtBySystem}
                              type="green"
                            />
                          </Typography>
                        )}
                      </Box>

                      <BasicEditableTable
                        columns={
                          user?.isSupplierFinance
                            ? [
                                ...INVOICE_FOR_DOC_COLUMNS,
                                {
                                  Header: "INVOICE QTY.",
                                  accessor: "invoiceQty",
                                  show: true,
                                },
                              ]
                            : INVOICE_FOR_DOC_COLUMNS
                        }
                        data={invoiceData}
                        updateLocalState={updateInvoiceData}
                        defaultColumn={editableTableDefaultColumn}
                        pageSize={100}
                      />
                      {(user?.isSupplierFinance ||
                        user?.isSupplierAdmin ||
                        user?.isSupplierOperation) && (
                        <Box sx={{ display: "inline" }}>
                          <Alert
                            severity="info"
                            sx={{
                              color: "skyblue",
                              display: "flex",
                              fontSize: "small",
                              // height: "10px",
                              backgroundColor: "white",
                            }}
                          >
                            Scroll right to add Invoice QTY{" "}
                          </Alert>
                        </Box>
                      )}

                      {!isOrderCompleted() &&
                        (user?.isSupplierFinance || user?.isSupplierAdmin) && (
                          <form onSubmit={updateInvoiceDetails}>
                            <Grid container spacing={2} marginY={1}>
                              <Grid item lg={6} sx={{ mt: -5 }}>
                                <TextField
                                  margin="normal"
                                  required
                                  variant="outlined"
                                  label={"Invoice number"}
                                  name="invoiceNumber"
                                  value={newInvoiceData.invoiceNumber}
                                  onChange={handleChange}
                                  inputProps={{ style: { fontSize: 12 } }}
                                  InputLabelProps={{ style: { fontSize: 15 } }}
                                  fullWidth
                                />
                              </Grid>
                              <Grid item lg={6}sx={{ mt: -5 }}>
                                <TextField
                                  margin="normal"
                                  variant="outlined"
                                  required
                                  type={"number"}
                                  disabled
                                  label={"Invoice amount (Without tax)"}
                                  name="invoiceAmtByUser"
                                  value={newInvoiceData.invoiceAmtByUser}
                                  onChange={handleChange}
                                  inputProps={{ style: { fontSize: 12 } }}
                                  InputLabelProps={{ style: { fontSize: 15 } }}
                                  fullWidth
                                />
                              </Grid>
                              <Grid item lg={12}>
                                <TextField
                                  margin="normal"
                                  variant="outlined"
                                  required
                                  type={"file"}
                                  onChange={(e) =>
                                    setInvoiceDoc(e.target.files[0])
                                  }
                                  fullWidth
                                  inputProps={{
                                    style: { fontSize: 12 },
                                    accept:
                                      "image/png, image/jpeg, image/jpg, application/pdf",
                                  }}
                                  InputLabelProps={{ style: { fontSize: 15 } }}
                                />
                              </Grid>
                              <Grid item lg={12}>
                                <Button
                                  variant="contained"
                                  type="submit"
                                  fullWidth
                                  disabled={invoiceAmtBySystem === 0}
                                >
                                  Save
                                </Button>
                              </Grid>
                            </Grid>
                          </form>
                        )}
                    </>
                  )}
                </CardContent>
              </Card>
            )}
            {invoicePartDetails && (
              <Grid container spacing={2}>
                {!invoiceNum &&
                  invoicePartDetails
                    .map((inv) => {
                      return (
                        <Grid item lg={12} md={12} sm={12}>
                          <InvoiceCard
                            invoice={inv}
                            handleInvoiceOpen={handleInvoiceOpen}
                            active={activeDoc}
                            notify={notifyCargoReady}
                            notifyCaroDelay={notifyCargoDelay}
                          />
                        </Grid>
                      );
                    })
                    .reverse()}
                {invoiceNum && (
                  <Grid item lg={isImpexOfficeUser ? 12 : 6} md={12} sm={12}>
                    <InvoiceCard
                      invoice={
                        invoicePartDetails.filter(
                          (invo) => invo.InvoiceNo === invoiceNum
                        )[0]
                      }
                      handleInvoiceOpen={handleInvoiceOpen}
                      active={activeDoc}
                      notify={notifyCargoReady}
                      notifyCaroDelay={notifyCargoDelay}
                    />
                  </Grid>
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
      {loading && <CircularProgress />}
    </>
  );
}

export default InvoiceDetails;
